import { TranslationMessages } from 'react-admin'

const messages: TranslationMessages = {
  ra: {
    action: {
      add_filter: 'Afegir filtre',
      add: 'Afegir',
      back: 'Tornar',
      bulk_actions: '1 element seleccionat |||| %{smart_count} elements seleccionats',
      cancel: 'Cancel·lar',
      clear_input_value: 'Netejar valor',
      clone: 'Clonar',
      create: 'Crear',
      delete: 'Eliminar',
      edit: 'Editar',
      export: 'Exportar',
      list: 'Llistar',
      refresh: 'Refrescar',
      remove_filter: 'Esborrar aquest filtre',
      remove: 'Esborrar',
      save: 'Desar',
      search: 'Cercar',
      show: 'Mostrar',
      sort: 'Ordenar',
      undo: 'Desfer',
      clear_array_input: 'Netejar llista',
      create_item: 'Crear element',
      remove_all_filters: 'Eliminar tots els filtres',
      select_all: 'Seleccionar tot',
      select_row: 'Seleccionar fila',
      unselect: 'Deseleccionar',
      expand: 'Expandir',
      close: 'Tancar',
      open_menu: 'Obrir menú',
      close_menu: 'Tancar menú',
      update: 'Actualitzar',
      move_up: 'Moure amunt',
      move_down: 'Moure avall',
      open: 'Obrir',
      toggle_theme: 'Canviar tema',
      select_columns: 'Seleccionar columnes',
      update_application: 'Actualitzar aplicació',
      confirm: 'Confirmar',
      select_all_button: 'Seleccionar-ho tot',
    },
    boolean: {
      true: 'Si',
      false: 'No',
      null: 'Nul',
    },
    page: {
      create: 'Crear %{name}',
      dashboard: 'Dashboard',
      edit: '%{name} #%{id}',
      error: "S'ha produït un error",
      list: 'Llista de %{name}',
      loading: 'Carregant',
      not_found: "No s'ha trobat",
      show: '%{name} #%{id}',
      empty: 'Sense contingut',
      invite: 'Convidar',
      access_denied: 'Accés denegat',
      authentication_error: "Error d'autenticació",
    },
    input: {
      file: {
        upload_several: 'Arrossega els fitxers a pujar o clica per seleccionar-ne un.',
        upload_single: 'Arrossega el fitxer a pujar o clica per seleccionar-lo.',
      },
      image: {
        upload_several: 'Arrossega les imatges a pujar o clica per seleccionar-ne una.',
        upload_single: 'Arrossega la imatge a pujar o clica per seleccionar-la.',
      },
      references: {
        all_missing: "No s'han pogut trobar referències.",
        many_missing: 'Al menys una de les referències associades no sembla estar disponible.',
        single_missing: 'La referència associada no sembla estar disponible.',
      },
      password: {
        toggle_visible: 'Amagar contrasenya',
        toggle_hidden: 'Mostrar contrasenya',
      },
    },
    message: {
      about: 'Sobre la versió',
      are_you_sure: 'Està segur?',
      bulk_delete_content: "Està segur d'eliminar l'element %{name}? |||| Està segur d'eliminar aquests %{smart_count} elements?",
      bulk_delete_title: 'Eliminar %{name} |||| Eliminar %{smart_count} %{name} elements',
      delete_content: "Està segur d'eliminar aquest element?",
      delete_title: 'Eliminar %{name} #%{id}',
      details: 'Detalls',
      error: "S'ha prodït un error al client i la seva petició no s'ha pogut completar.",
      invalid_form: 'El formulari no és vàlid. Si us plau, revisi els errors',
      loading: "La pàgina s'està carregant, esperi un moment si us plau",
      no: 'No',
      not_found: 'O bé ha escrit una URL incorrecta, o bé ha navegat a un enllaç erroni.',
      yes: 'Sí',
      auth_error: "Error d'autenticació",
      bulk_update_content:
        'Està segur que vol actualitzar aquest %{name}? |||| Està segur que vol actualitzar aquests %{smart_count} elements?',
      bulk_update_title: 'Actualitzar %{name} |||| Actualitzar %{smart_count} %{name}',
      clear_array_input: 'Està segur que vol esborrar tota la llista?',
      unsaved_changes: "Alguns canvis no s'han desat. Està segur que vol ignorar-los?",
      access_denied: 'Accés denegat',
      authentication_error: "Error d'autenticació",
      select_all_limit_reached: "S'ha assolit el límit de selecció",
    },
    navigation: {
      no_results: 'Sense resultats',
      no_more_results: 'La pàgina número %{page} està fora de rang. Provi amb la pàgina anterior.',
      page_out_of_boundaries: 'Pàgina número %{page} fora de rang',
      page_out_from_end: 'No es pot anar més enllà de la última pàgina',
      page_out_from_begin: 'No es pot anar més enllà de la pàgina 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      page_rows_per_page: 'Files per pàgina:',
      next: 'Següent',
      prev: 'Anterior',
      no_filtered_results: 'No hi ha resultats pel filtre actual',
      clear_filters: 'Netejar filtres',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} de més de %{total}',
      current_page: 'Pàgina %{page}',
      page: 'Anar a la pàgina %{page}',
      first: 'Anar a la primera pàgina',
      last: "Anar a l'última pàgina",
      previous: 'Anterior',
      skip_nav: 'Saltar al contingut',
    },
    auth: {
      user_menu: 'Perfil',
      username: 'Usuari',
      password: 'Contrasenya',
      email: 'Correu electrònic',
      sign_in: 'Iniciar sessió',
      sign_in_error: "Ha fallat l'autenticació, si us plau torni a provar-ho",
      logout: 'Tancar sessió',
      auth_check_error: "Error al verificar l'autenticació",
    },
    notification: {
      updated: 'Element actualitzat |||| %{smart_count} elements actualitzats',
      created: 'Element creat',
      deleted: 'Element eliminat |||| %{smart_count} elements eliminats',
      bad_item: 'Element incorrecte',
      item_doesnt_exist: "L'element no existeix",
      http_error: 'Error de comunicació amb el servidor',
      data_provider_error: 'Error del dataProvider. Comprova la consola per més detalls.',
      canceled: 'Acció cancel·lada',
      i18n_error: 'Error de traducció',
      logged_out: 'La seva sessió ha finalitzat',
      not_authorized: 'No autoritzat',
      application_update_available: 'Una nova versió està disponible',
    },
    validation: {
      required: 'Obligatori',
      minLength: 'Longitud mínima de %{min} caràcters',
      maxLength: 'Longitud màxima de %{max} caràcters',
      minValue: 'El valor mínim és %{min}',
      maxValue: 'El valor màxim és %{max}',
      number: 'Ha de ser un valor numèric',
      email: 'Ha de ser una adreça electrònica vàlida',
      oneOf: "Ha de ser un d'aquests valors: %{options}",
      regex: 'Ha de complir el format (expressió regular): %{pattern}',
    },
    sort: {
      sort_by: 'Ordenar per',
      ASC: 'Ascendent',
      DESC: 'Descendent',
    },
    saved_queries: {
      label: 'Consultes desades',
      query_name: 'Nom de la consulta',
      new_label: 'Nova consulta',
      new_dialog_title: 'Desar consulta actual com',
      remove_label: 'Eliminar consulta desada',
      remove_label_with_name: 'Eliminar consulta "%{name}"',
      remove_dialog_title: 'Eliminar consulta desada',
      remove_message: 'Està segur que vol eliminar aquesta consulta?',
      help: 'Filtrar la llista i desar aquesta consulta per més tard',
    },
    configurable: {
      customize: 'Personalitzar',
      configureMode: 'Configurar pàgina',
      inspector: {
        title: 'Inspector',
        content: 'Contingut',
        reset: 'Restablir',
        hideAll: 'Amagar tot',
        showAll: 'Mostrar tot',
      },
      Datagrid: {
        title: 'Taula',
        unlabeled: 'Columna sense etiqueta',
      },
      SimpleForm: {
        title: 'Formulari',
        unlabeled: 'Camp sense etiqueta',
      },
      SimpleList: {
        title: 'Llista',
        primaryText: 'Text principal',
        secondaryText: 'Text secundari',
        tertiaryText: 'Text terciari',
      },
    },
  },
}

export default messages
